module.exports = __webpack_public_path__ + "static/media/fondo.bb2abbbc.jpg";